import { render, staticRenderFns } from "./OrderListReturnNew.vue?vue&type=template&id=2058eeb5&scoped=true"
import script from "./OrderListReturnNew.vue?vue&type=script&lang=js"
export * from "./OrderListReturnNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListReturnNew.vue?vue&type=style&index=0&id=2058eeb5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058eeb5",
  null
  
)

export default component.exports